import { render } from "./ResetPassword.vue?vue&type=template&id=1cc50333&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import "./ResetPassword.vue?vue&type=style&index=0&id=1cc50333&lang=scss&scoped=true"
import "./ResetPassword.vue?vue&type=style&index=1&id=1cc50333&lang=scss"

import exportComponent from "F:\\ds_pc_new\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc50333"]])

export default __exports__